export default "//cloud.imgsmail.ru/cloud.mail.ru/168288/img/build/aside-promo-modal/kaspersky-cover.jpg";